import React from 'react';
import { useSelector } from 'react-redux';
import {
  SharedTemplateAboutModal,
  SharedTemplateDeleteModal,
  SharedTemplateDuplicateModal,
  SharedTemplateEditModal,
  SharedTemplateSaveModal,
  SharedTemplateShareModal,
  SharedTemplateTriOptionModal,
  SharedTemplateUnsavedModal,
} from '../presentational/sharedTemplateComponents';

const LoadMonitoringTemplateModals = () => {
  const lmAboutModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.aboutModalShowing,
  );
  const lmDeleteModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.deleteModalShowing,
  );
  const lmDuplicateModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.duplicateModalShowing,
  );
  const lmEditModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.editModalShowing,
  );
  const lmSaveModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.saveModalShowing,
  );
  const lmShareModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.shareModalShowing,
  );
  const lmTriOptionModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.triOptionModalShowing,
  );
  const unsavedLMDashModalShowing = useSelector(
    (state) => state.loadMonitoringDashboard.ui.unsavedModalShowing,
  );

  return (
    <>
      {lmAboutModalShowing && (
        <SharedTemplateAboutModal dashboard='Load Monitoring' />
      )}
      {lmDeleteModalShowing && (
        <SharedTemplateDeleteModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {lmDuplicateModalShowing && (
        <SharedTemplateDuplicateModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {lmEditModalShowing && (
        <SharedTemplateEditModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {lmSaveModalShowing && (
        <SharedTemplateSaveModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {lmShareModalShowing && (
        <SharedTemplateShareModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {lmTriOptionModalShowing && (
        <SharedTemplateTriOptionModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
      {unsavedLMDashModalShowing && (
        <SharedTemplateUnsavedModal
          dashboard='Load Monitoring'
          legacyName='Load Monitoring'
        />
      )}
    </>
  );
};

export default LoadMonitoringTemplateModals;
